import {handleActions} from "../Utility/HandleActions";

export const reducer = handleActions({
    // This reducer is now mostly obsolete as we are not using connected-react-router.
    // We can keep it for now to avoid breaking other parts of the app that might still be using the selector.
    'CUSTOM_LOCATION_CHANGE': (payload) => (state) => {
        const location = { ...payload, query: Object.fromEntries(new URLSearchParams(payload.search)) };
        return state.setIn(['router', 'locationBeforeTransitions'], location);
    },
});

const locationBeforeTransitions = state => state.getIn(['router', 'locationBeforeTransitions']) || {};

export const selectors = {
    locationBeforeTransitions
};